import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import LayoutProvider from "../Providers/LayoutProvider";
import {useSelector} from "react-redux";

export const PrivateRoutes = ({fullWidth = false, layout}) => {

    const {isLoggedIn} = useSelector((store) => store.auth);

    return isLoggedIn ?
        (<LayoutProvider layout={layout} fullWidth={fullWidth}>
            <Outlet/>
        </LayoutProvider>)
        : <Navigate to="/login"/>;
}

